import Box from "@mui/material/Box";
import PropTypes from "prop-types";

export default function Slide({ children }: any) {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        marginY: "0.5rem",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </Box>
  );
}

Slide.propTypes = {
  children: PropTypes.node,
};
